module.exports = __webpack_public_path__ + "static/media/Buss.50c13acc.PNG";